<div class="flex flex-row h-full overflow-y-auto">
  <div class="h-full" *ngIf="shouldShowNav$ | async">
    <sa-nav></sa-nav>
  </div>
  <div class="w-full relative h-full overflow-y-auto mainPanel">
    <sa-versioning></sa-versioning>
    <sa-stage-url-indicator *saOnlyEnv="['dev', 'stage']"></sa-stage-url-indicator>
    <sa-order-unique-id-search></sa-order-unique-id-search>
    <router-outlet></router-outlet>
  </div>
</div>
